export default {
    primary: {
        dark: "hsl(86, 51%, 33%)",
        base: "hsl(86, 51%, 50%)",
        light: "hsl(86, 51%, 69%)"
    },
    secondary: {
        dark: "hsl(206, 46%, 25%)",
        base: "hsl(206, 100%, 32%)",
        light: "hsl(206, 48%, 73%)",
        accent: "hsl(198, 100%, 40%)"
    },
    neutral: {
        dark: "hsl(210, 33%, 10%)",
        base: "hsl(210, 30%, 14%)",
        light: "hsl(210, 22%, 20%)",
        lighter: "hsl(210, 30%, 22%)"
    },
    ink: {
        base: "hsl(206, 25%, 96%)",
        dark: "hsl(206, 30%, 88%)",
        darker: "hsl(206, 20%, 78%)"
    },
    warning: {
        text: "hsl(360, 60%, 34%)",
        base: "hsl(360, 60%, 50%)",
        light: "hsl(360, 56%, 85%)",
        lighter: "hsl(14, 73%, 94%)",
    },
    success: {
        text: "hsl(109, 12%, 28%)",
        base: "hsl(110, 51%, 48%)",
        light: "hsl(110, 49%, 80%)",
        lighter: "hsl(107, 39%, 91%)",
    },
    attention: {
        text: "hsl(48, 30%, 27%)",
        base: "hsl(48, 100%, 50%)",
        light: "hsl(48, 100%, 80%)",
        lighter: "hsl(46, 89%, 90%)",
    },
    black: "#000000",
    white: "#ffffff",
    whites: {
        90: "rgba(255,255,255,0.9)",
    },
}